import React from 'react';

import Box from '@mui/material/Box';
import Avatar from '@mui/material/Avatar';

import Typography from '@ts-core/components/Typography';
import { getStringAvatarText } from '@ts-core/core/utils';
import TimeAgo from '@ts-core/components/TimeAgo';

import { Message } from '../../types';

export interface MessageDetailsProps {
  message?: Message;
  loading?: boolean;
}

const MessageDetails = (props: MessageDetailsProps) => {
  const { message, loading = false } = props;

  if (loading) {
    return <span />;
  }

  if (!message) {
    return <Box>Selecciona un mensaje para ver los detalles</Box>;
  }

  return (
    <Box width="100%" height="100%">
      <Box display="flex" flexDirection="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h5">{message.message.title}</Typography>
        <Typography variant="body1">{message.course.name}</Typography>
      </Box>
      <Box
        width="100%"
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        pb={2}
        borderBottom="1px solid rgba(0, 0, 0, 0.1)"
      >
        <Box display="flex" flexDirection="row" mt={2} alignItems="center">
          <Avatar>{getStringAvatarText(message?.sender.name)}</Avatar>
          <Typography ml={1}>{message.sender.name}</Typography>
        </Box>
        <TimeAgo date={message.message.date} />
      </Box>
      <Box mt={2}>{message.message.content}</Box>
    </Box>
  );
};

export default MessageDetails;
